import { render } from "./CoefficientsView.vue?vue&type=template&id=be0f6e84&scoped=true&ts=true"
import script from "./CoefficientsView.vue?vue&type=script&lang=ts"
export * from "./CoefficientsView.vue?vue&type=script&lang=ts"

import "./CoefficientsView.vue?vue&type=style&index=0&id=be0f6e84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0f6e84"]])

export default __exports__